export var ExamOneRequestType;
(function (ExamOneRequestType) {
    ExamOneRequestType["GET_IN_CENTER_LOCATIONS"] = "getInCenterLocations";
    ExamOneRequestType["GET_IN_CENTER_TIMES"] = "getInCenterTimes";
    ExamOneRequestType["GET_MOBILE_TIMES"] = "getMobileTimes";
})(ExamOneRequestType || (ExamOneRequestType = {}));
//# sourceMappingURL=cloudPython.js.map